import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ colors }: Theme) => createStyles({
  editIcon: {
    '& path': {
      fill: colors.uIIconBase,
    },
    '&:hover': {
      '& path': {
        fill: colors.uIBase,
      },
    },
  },
});

export default styles;
